import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="oglitz-projects-hero">
      <div className="oglitz-projects-hero-inner">
        {/* Badge */}
        <span className="oglitz-projects-badge">Our Work & Case Studies</span>

        {/* Main Heading */}
        <h1>
          Projects That Turn Ideas Into
          <span> Scalable Digital Products</span>
        </h1>

        {/* Description */}
        <p>
          Explore real-world web and mobile applications crafted by Oglitz. From
          startups to enterprises, we design and develop secure, scalable, and
          performance-driven software solutions that deliver measurable business
          impact.
        </p>

        {/* Trust Stats */}
        <div className="oglitz-projects-stats">
          <div>
            <strong>50+</strong>
            <span>Projects Delivered</span>
          </div>
          <div>
            <strong>15+</strong>
            <span>Industries Served</span>
          </div>
          <div>
            <strong>Global</strong>
            <span>Client Reach</span>
          </div>
        </div>

        {/* CTA */}
        <div className="oglitz-projects-hero-actions">
          <a href="/contact" className="oglitz-btn-primary">
            Start Your Project
          </a>
          <a href="/services" className="oglitz-btn-secondary">
            View Our Services
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
